import { BaseFormState } from '~/types/BaseFormState';
import styles from './Validation.module.css';
import { FormState } from 'react-hook-form';

interface Props<TFormState extends BaseFormState> {
  formState?: FormState<TFormState>;
  htmlFor: keyof TFormState;
}

export function Validation<TFormState extends BaseFormState>(props: Props<TFormState>) {
  const { formState, htmlFor } = props;

  if (!formState?.errors[htmlFor]?.message) {
    return false;
  }

  return <small className={styles.validation}>{formState.errors[htmlFor]?.message as string}</small>;
}
